export default {
    center: {
        lat: null,
        lng: null,
    },
    data: {
        id: null,
        postcode: null,
        title: null,
    },
};
